import React, { Component } from 'react'
import classnames from 'classnames'
import TetherComponent from 'react-tether'
import { ToolTip } from '@driftt/tide-core-legacy'

class TetheredToolTip extends Component {
  state = {
    hovering: false
  }

  toggleHover = () => {
    this.setState({
      hovering: true
    })
  }

  toggleHoverOff = () => {
    this.setState({
      hovering: false
    })
  }

  render() {
    const { hovering } = this.state
    const { children, component, flow, attachment='middle left', className, disabled = false } = this.props

    return (
      <div
        onMouseOver={this.toggleHover}
        onMouseOut={this.toggleHoverOff}
      >
      <TetherComponent
        attachment={attachment}
        className={classnames({[className]: !!className})}
      >
          {children}
          {hovering && !disabled && (
            <ToolTip
              flow={flow}
              open
              component={component}
            />
          )}
        </TetherComponent>
      </div>
    )
  }
}

export default TetheredToolTip



// WEBPACK FOOTER //
// ./src/scripts/components/TetheredToolTip/index.js